import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchStorageService {
  private readonly SEARCH_SUFFIX = '_basicSearchKey';
  private isRefreshing = false;

  constructor() {
    this.setupBeforeUnloadHandler();
  }

  private setupBeforeUnloadHandler(): void {
    window.addEventListener('beforeunload', () => {
      this.isRefreshing = true;
      this.clearAllSearchKeys();
    });
  }


  private getStorageKey(componentName: string): string {
    return `${componentName}${this.SEARCH_SUFFIX}`;
  }


  saveSearch(componentName: string, searchText: string): void {
    if (this.isRefreshing) return;

    const key = this.getStorageKey(componentName);

    try {
      if (searchText && searchText.trim()) {
        localStorage.setItem(key, searchText.trim());
      } else {
        this.removeSearch(componentName);
      }
    } catch (error) {
      console.error(`Failed to save search for ${componentName}:`, error);
    }
  }

  getSearch(componentName: string): string | null {
    const key = this.getStorageKey(componentName);

    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(`Failed to retrieve search for ${componentName}:`, error);
      return null;
    }
  }


  removeSearch(componentName: string): void {
    const key = this.getStorageKey(componentName);

    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Failed to remove search for ${componentName}:`, error);
    }
  }


  private clearAllSearchKeys(): void {
    try {
      const keys = Object.keys(localStorage);
      const searchKeys = keys.filter(key => key.endsWith(this.SEARCH_SUFFIX));

      searchKeys.forEach(key => {
        localStorage.removeItem(key);
      });
    } catch (error) {
      console.error('Failed to clear search keys:', error);
    }
  }

  hasSearch(componentName: string): boolean {
    return this.getSearch(componentName) !== null;
  }
}
